import moment from 'moment';
import { MUIDataTableColumn } from 'mui-datatables';
import { FileData } from 'src/dataFactory/depositionFactory';
import { bytesToSize } from 'src/utils/fileUtils';
import { DateTimeFormatDisplay } from 'src/utils/momentUtils';

export type FileDataTableRow = Omit<FileData, 'lastModified' | 'type' | 'name'> & {
  name: [FileData['name'], FileData['extension']];
  lastModified: FileData['updatedDate'];
  type: FileData['extension'];
};

export type FileDataTableColumn = MUIDataTableColumn & {
  name: keyof FileDataTableRow;
};

export const FileName = ([name, extension]: FileDataTableRow['name']) => {
  return `${name}.${extension}`;
};

export const FileModifiedDate = (value: string) => {
  return moment(value).format(DateTimeFormatDisplay);
};

export const FileExtension = (value: string) => {
  if (value) return value.toUpperCase() + ' File';
  return '--';
};

export const FileSize = (value: string) => {
  if (value) return bytesToSize(Number(value));
  return '--';
};

export const columns: FileDataTableColumn[] = [
  {
    name: 'name',
    label: 'Name',
    options: {
      filter: false,
      sort: true,
      customBodyRender: FileName,
    },
  },
  {
    name: 'lastModified',
    label: 'Last Modified',
    options: { filter: false, sort: true, customBodyRender: FileModifiedDate },
  },
  { name: 'type', label: 'Type', options: { filter: false, sort: true, customBodyRender: FileExtension } },
  { name: 'size', label: 'Size', options: { filter: false, sort: true, customBodyRender: FileSize } },
];
